import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { ExecutionHistoryService } from '../execution-history.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from '@app/_shared/date-formatter.service';
import { CustomDateAdapterService } from '@app/_services/custom-date-adapter.service';

@Component({
  selector: 'app-new-execution-history',
  templateUrl: './new-execution-history.component.html',
  styleUrls: ['./new-execution-history.component.less'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomDateAdapterService },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ]
})
export class NewExecutionHistoryComponent implements OnInit {
  myProjects: any[];
  users: any[];
  testCaseResultList: any[];
  masterSuiteResultList: any = [];
  testSuiteResultList: any = [];
  dataList: any;
  executionType: any;

  previousPage: any;
  executionStatusList: any[];
  page: number = 1;
  pageSize = 15;
  dataNotFound = false;
  moreData = true;
  dataLoaded = false;

  historyListSearchForm: FormGroup;
  minDate: NgbDateStruct;
  maxDate: any;
  currentUser = JSON.parse(localStorage.getItem('user'));

  constructor(private titleService: Title, private router: Router, private executionHistoryService: ExecutionHistoryService, private route: ActivatedRoute,
    private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.getMyProjects();
    this.getUsers();
    this.initialiseHistorySearchForm();
    this.executionStatusList = JSON.parse(localStorage.getItem('about')).executionStatuses;
    this.route.queryParams.subscribe((params) => {
      let searchParams = JSON.parse(JSON.stringify(params));
      this.executionType = searchParams.executionType;
      if(searchParams.default === undefined) {
        if(localStorage.getItem("defaultUserConfig") !== null && JSON.parse(localStorage.getItem("defaultUserConfig")).default_project) {
          searchParams.projectIds = [JSON.parse(localStorage.getItem("defaultUserConfig")).default_project];
        }
      } else {
        delete searchParams.default;
      }
      this.setSearchFormParams(searchParams);
      this.setMaxDate();
      this.getExecutionHistory(searchParams);
      if(searchParams.executionType === 'TEST_CASE') {
        this.titleService.setTitle('Exec-History | TC');
      } else if(searchParams.executionType === 'TEST_SUITE') {
        this.titleService.setTitle('Exec-History | TS');
      } else if(searchParams.executionType === 'MASTER_SUITE') {
        this.titleService.setTitle('Exec-History | MS');
      }
    });
  }

  initialiseHistorySearchForm() {
    this.historyListSearchForm = this.formBuilder.group({
      projectIds: [null],
      executedBy: null,
      executionStatus: null,
      fromDate: null,
      toDate: null,
      keyword:null,
      executionType: null
    });
  }

  setSearchFormParams(params: any) {
    if (params.executedBy) { this.historyListSearchForm.get('executedBy').setValue(JSON.parse(params.executedBy)); }
    if (params.executionStatus) { this.historyListSearchForm.get('executionStatus').setValue(params.executionStatus); }
    if (params.fromDate) { this.historyListSearchForm.get('fromDate').setValue(params.fromDate); }
    if (params.toDate) { this.historyListSearchForm.get('toDate').setValue(params.toDate); }
    if (params.keyword) { this.historyListSearchForm.get('keyword').setValue(params.keyword); }
    if (params.executionType) { this.historyListSearchForm.get('executionType').setValue(params.executionType); }
    if (params.projectIds) {
      let projects = [];
      if (Array.isArray(params.projectIds)) {
        projects = params.projectIds.map((val) => {
          return parseInt(val, 10);
        });
      } else {
        const projectId = parseInt(params.projectIds, 10);
        projects.push(projectId);
      }
      this.historyListSearchForm.get('projectIds').setValue(projects);
    }
  }

  getMyProjects() {
    this.executionHistoryService.getMyProjectList().pipe().subscribe(data => {
      if (data.code === 200) {
        this.myProjects = data.response;
      }
    });
  }

  getUsers() {
    this.executionHistoryService.getUsersList().pipe().subscribe(data => {
      if (data.code === 200) {
        this.users = data.response;
      }
    });
  }

  getExecutionHistory(searchParams) {
    this.dataNotFound = false;
    const collection = {
      page: this.page || 1,
      size: this.pageSize || 15,
      executionType: this.executionType,
    };
    searchParams = { ...collection, ...searchParams };
    this.executionHistoryService.getExecutionHistory(searchParams).pipe().subscribe(data => {
      if (data.code === 200) {
        this.dataList = [];
        this.dataLoaded = true;
        if(searchParams.executionType === 'TEST_CASE') {
          this.dataList = data.response.testCases;
        } else if(searchParams.executionType === 'TEST_SUITE') {
          this.dataList = data.response.testSuites;
        } else if(searchParams.executionType === 'MASTER_SUITE') {
          this.dataList = data.response.masterSuites;
        }
        this.page = searchParams.page;
        if (this.dataList.length < this.pageSize) this.moreData = false;
        else this.moreData = true;
      } else {
        this.dataNotFound = true;
        this.moreData = false;
        this.dataList = [];
      }
    });
  }

  setMaxDate() {
    this.maxDate = { year: new Date().getFullYear(), month: (new Date().getMonth() + 1), day: new Date().getDate() };
  }

  setMindate() {
    if(null === this.historyListSearchForm.value.fromDate){
      this.historyListSearchForm.get('toDate').setValue(null);
    }
    const date = new Date(this.historyListSearchForm.value.fromDate);
    this.minDate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
  }

  clearSearchFilter() {
    let searchParams;
    const collection = {
      page: this.page || 1,
      size: this.pageSize || 15,
      executionType: this.executionType,
      default: false
    };
    searchParams = { ...collection, ...searchParams };
    this.initialiseHistorySearchForm();
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: searchParams });
  }

  filterData() {
    this.page = 1;
    let searchParams = this.historyListSearchForm.value;
    const collection = {
      page: this.page || 1,
      size: this.pageSize || 15,
      executionType: this.executionType,
      default: false
    };
    searchParams = { ...collection, ...searchParams };
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: searchParams });
  }

  loadmore(page) {
    this.moreData = true;
    this.page = parseInt(page) + 1
    let searchParams = this.historyListSearchForm.value;
    const collection = {
      page: this.page || 1,
      size: this.pageSize || 15,
      executionType: this.executionType
    };
    searchParams = { ...collection, ...searchParams };
    this.executionHistoryService.getExecutionHistory(searchParams).pipe().subscribe(data => {
      if (data.code === 200) {
        if(searchParams.executionType === 'TEST_CASE') {
          data.response.testCases.map(testcase => {
            this.dataList.push(testcase);
          });
        } else if(searchParams.executionType === 'TEST_SUITE') {
          data.response.testSuites.map(testsuite => {
            this.dataList.push(testsuite);
          });
        } else if(searchParams.executionType === 'MASTER_SUITE') {
          data.response.masterSuites.map(mastersuite => {
            this.dataList.push(mastersuite);
          });
        }
        data.response.testCases.map(testcase => {
          this.dataList.push(testcase);
        });
      } else {
        this.moreData = false;
      }
    });
  }

}
